import React, { useMemo, useCallback } from 'react';

import { Typography } from '@hpstellar/core';

const WPM = 225;

export default ({ blogContent, vanityUrl }) => {
    const getReadingTime = useCallback(blogContent => {
        try {
            let blocks = JSON.parse(blogContent).blocks;
            let textContent = blocks
                .reduce((fullText, block) => fullText + (block && typeof block.text === 'string' ? block.text : ''), '')
                .trim();
            let wordCount = textContent.split(/\s+/).length;
            let time = Math.ceil(wordCount / WPM);
            return time;
        } catch (e) {}

        return null;
    }, []);

    const readingTime = useMemo(() => {
        return getReadingTime(blogContent);
    }, [vanityUrl, blogContent && blogContent.length]);

    return (
        readingTime && (
            <Typography style={{ display: 'block' }} className="blog-reading-time" variant="bodyM" tag="div">
                {`Reading time: ${readingTime} minute${readingTime > 1 ? 's' : ''}`}
            </Typography>
        )
    );
};
